import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { fmtDate, fmtRelative } from "@/lib/format";
import { Skeleton } from "@/components/ui/skeleton";

const ACTION_LABELS = {
  "return.created": "Cerere retur creată",
  "return.update": "Retur modificat",
  "return.status_change": "Status schimbat",
  "return.note_added": "Notă adăugată",
  "return.delete": "Retur șters",
  "status.create": "Status creat",
  "status.update": "Status modificat",
  "status.delete": "Status șters",
  "status.reorder": "Statusuri reordonate",
};

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs").then((r) => setLogs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2">Setări</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Audit log</h1>
        <p className="text-muted-foreground text-sm mt-1">Istoric complet al acțiunilor din platformă.</p>
      </div>

      <Card className="p-6 bg-card border-border">
        {loading ? (
          <div className="space-y-3">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-12 w-full" />)}</div>
        ) : logs.length === 0 ? (
          <div className="text-center text-muted-foreground text-sm py-12">Niciun eveniment înregistrat.</div>
        ) : (
          <div className="space-y-3">
            {logs.map((log) => (
              <div key={log.id} className="flex items-start gap-3 pb-3 border-b border-border last:border-b-0 last:pb-0" data-testid={`audit-${log.id}`}>
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-secondary text-xs font-semibold">
                    {(log.actor_name || "S").split(" ").map((p) => p[0]).join("").slice(0, 2)}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <div className="text-sm">
                    <span className="font-medium">{log.actor_name || "Sistem"}</span>
                    <span className="text-muted-foreground"> · {ACTION_LABELS[log.action] || log.action}</span>
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge variant="outline" className="text-[10px] font-mono">{log.resource_type}</Badge>
                    <span className="text-xs text-muted-foreground">{fmtDate(log.created_at)} · {fmtRelative(log.created_at)}</span>
                  </div>
                  {log.details && Object.keys(log.details).length > 0 && (
                    <div className="text-xs font-mono text-muted-foreground/80 mt-1 truncate">{JSON.stringify(log.details)}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
